import type { ComponentPropsWithoutRef } from "react";

import dayjs, { type Dayjs } from "@eisox/dayjs";
import { cn, DateField } from "@eisox/design-system";

import { DATE_FORMAT } from "~/constants/date.constant";

export interface PeriodProps extends ComponentPropsWithoutRef<"div"> {
  begin: string;
  end: string;
  onBeginChange: (begin?: string) => void;
  onEndChange: (end?: string) => void;
  disabled?: boolean;
}

export const Period: React.FC<PeriodProps> = ({
  begin,
  end,
  onBeginChange,
  onEndChange,
  disabled,
  className,
  ...props
}) => {
  const handleChangeBeginValue = (value: Dayjs | null) => {
    if (value) onBeginChange(value.format(DATE_FORMAT));
  };

  const handleChangeEndValue = (value: Dayjs | null) => {
    if (value) onEndChange(value.format(DATE_FORMAT));
  };

  return (
    <div {...props} className={cn("grid flex-1 grid-cols-[1fr_30px_1fr] items-center", className)} data-testid="period">
      <DateField.Root
        className="w-full"
        value={begin ? dayjs(begin) : null}
        onValueChange={handleChangeBeginValue}
        disabled={disabled}
      >
        <DateField.Input className="w-full" />
      </DateField.Root>
      <span className="text-center">-</span>
      <DateField.Root
        className="w-full"
        value={end ? dayjs(end) : null}
        onValueChange={handleChangeEndValue}
        disabled={disabled}
      >
        <DateField.Input className="w-full" />
      </DateField.Root>
    </div>
  );
};

Period.displayName = "Period";
